var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"b-text-image"},[_c('asset',{class:_vm.imgPosition,attrs:{"asset":_vm.data.image,"shape":_vm.data.assetShape}}),_c('div',{staticClass:"t-cms",domProps:{"innerHTML":_vm._s(_vm.data.text)}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }